__webpack_require__.p = "https://micro-frontend-test-remote.pages.dev/";